import React, { useEffect, useState }  from 'react';
import {experiments_being_analysed} from '../../../service/apis';
import auth from '../../../service/Auth';
import { Redirect } from "react-router-dom";
import PopupMessage from '../components/PopupMessage';
import { downloadCSV } from '../../../service/CsvButton';
import TableView from '../components/TableView';

const config = window.config;

const headers = [
    { label: "Group" , key: "group",tooltip: "Experiment group owner."},
    { label: "Experiments Declared" , key: "total_declared",tooltip: "Experiments declared and waiting to be analysed." },
    { label: "Experiments In Process" , key: "total_inprocess" ,tooltip: "Experiments being processed."},
    { label: "Experiments gVCF Ready" , key: "total_gvcf",tooltip: "Experiments having its gVCF generated and ready to be pushed to the GPAP." },
    { label: "Experiments Failed" , key: "total_failed", tooltip: "Experiments that have failed on the analysis pipeline." }        
];


const ExperimentSummary = (props) => {

    const [data, setData] = useState({});
    const [errors, setErrors] = useState("");
    const [loading, setLoading] =  useState(true);
    const [extendedInfo, setExtendedInfo] = useState({});
    const [type, setType] = useState("");
    const [group, setGroup] = useState("");
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);    

    const fetchData = async () => {
        // GET EXPERIMENTS BEING PROCESSED
        await experiments_being_analysed(auth.getToken(),config.api_endpoint)
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setData(data);
            setLoading(false);
        });
    }

    useEffect(() => {
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setErrors("User does not have admin permissions.");
        }
        else if (props.location.data === undefined) {
            fetchData();
        }
        else {
            setData(props.location.data);
            setLoading(false);
        }
    },[])

    const updateColumns = () => {
        let cols = []
        for (let header of headers) {
              let col = {};
              col["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
              col["accessor"] = header.key;
              col["minWidth"] = 220;
              cols.push(col);
        }
        setColumns(cols);
    }  

    const updateRows = () => {
        let tableRows = [];
        // 1. Loop over group_stats objects to render the table contents
        for (let group in data) {
            if (group === "all") continue;
            let rowTable = {}; 
            //1. Loop Headers
            for (let column of columns){
                rowTable[column.accessor] = data[group][column.accessor];
            }
            rowTable["group"] = group;
            //2. Add row to data
            tableRows.push(rowTable);
        }
        // 2. All counts
        if ("all" in data){
            let rowTable = {};
            for (let column of columns){
                rowTable[column.accessor] = data["all"][column.accessor];
            }
            rowTable["group"] = "all";
            tableRows.push(rowTable);
        }
        // 3.Update Rows
        setRows(tableRows);
    }

    useEffect(() => {
        // 1. Update Table Columns
        updateColumns(); 
        // 2. Update Rows with the updated data memeber
        updateRows();
    },[data])

    /* Define a method to control Row Clicks*/
    const onRowClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {
                /*1.If row is Experiment ID then Route to Experiment Information*/
                setGroup(rowInfo.original.group);
                setType(column.id);
            },
            style: {
                cursor: 'pointer'
            },
        }
    };

    const getCsvData = (events) => {
        //1. Trigger Download CSV
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(rows,headers,`${today}_experiment_summary.csv`);
    }

    /*Show popup in case an error with the loggin occurs*/
    if (errors !== "") {
        return <PopupMessage title={"Logging error!"} message={errors} href={"#/admin"} />;
    }
    else if(type !== "") {
        return <Redirect to={{pathname:'/admin/experimentstatusinfo',group:group,apiInfo:data,type:type}}/>;
    }
    else {
        return (
            <TableView 
                title = {"Experiments being analysed"}
                href = {"#/admin"}
                getCsvData = {getCsvData}
                rows = {rows}
                columns = {columns}
                onRowClick = {onRowClick}
                height = {700}
                loading = {loading}
            />
        );
    }
}

export default ExperimentSummary;